import Api from '/core/services/Api';

export const fetchAllCourses = async() => {
    try {
      const response = await Api.get(`courses`);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchAllAreaCourses = async(id) => {
    try {
      const response = await Api.get(`area-courses/`+id);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchAllAreaCourseTypeCourses = async(id, ct) => {
    try {
      const response = await Api.get(`area-courses/`+id+'/course-types/'+ct);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchAllCourseTypeCourses = async(ct) => {
    try {
      const response = await Api.get(`courses-course-types/`+ct);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchOneCourse = async(ct) => {
    try {
      const response = await Api.get(`courses/`+ct);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const fetchOneBookCourse = async(ct) => {
    try {
      const response = await Api.get(`courses/`+ct+'/book');

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const bookOneCourseIndividual = async(ct,obj) => {
    try {
      const response = await Api.post(`courses/`+ct+'/individual', obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};

export const bookOneCourseOrganisation = async(ct,obj) => {
    try {
      const response = await Api.post(`courses/`+ct+'/organisation', obj);

      return response;
    } catch (error) {
      return Api.technicalError();
    }
};